export enum OrgInviteType {
    vetting_request = 'VETTING_REQUEST',
    supplier_nomination = 'SUPPLIER_NOMINATION',
}